import { Profile } from '../types/profiles';
import { getUserRoleCode } from './userRoleUtils';

interface OwnerAdminUser {
  isAdmin?: boolean;
  isOwnerCustomer?: boolean;
  role?: { code?: string } | string;
}

export function canManageTenantWorkflows(user: OwnerAdminUser | null | undefined): boolean {
  const roleCode = getUserRoleCode(user);
  return roleCode === 'admin' || roleCode === 'manager';
}

export function canManageSystemWorkflows(user: OwnerAdminUser | null | undefined): boolean {
  return Boolean(user?.isAdmin && user?.isOwnerCustomer);
}

export function canManageCrossCustomerUsers(user: OwnerAdminUser | null | undefined): boolean {
  return Boolean(user?.isAdmin && user?.isOwnerCustomer);
}

export function canAssignAdministratorProfile(targetCustomerIsOwner: boolean): boolean {
  return targetCustomerIsOwner;
}

export function getAssignableProfiles(profiles: Profile[], targetCustomerIsOwner: boolean): Profile[] {
  if (targetCustomerIsOwner)
  {
    return profiles;
  }

  return profiles.filter(profile => profile.type !== 'admin');
}

export function isAdministratorProfile(profile: Pick<Profile, 'type'> | null | undefined): boolean {
  return profile?.type === 'admin';
}
